<template>
  <v-form
    @submit.prevent="submit"
  >
    <v-card-title
      class="text-center d-block full-width py-4 text-uppercase caption font-weight-bold"
    >
      {{ title }}
    </v-card-title>

    <v-card-text>
      <v-alert
        v-if="isRegistering"
        outlined
        color="primary"
        text
        dense
        icon="visibility"
        class="caption mb-8"
      >
        Huomaathan, että koeaikana eli 1. viikon ajan sinulla on vain katseluoikeus. Tämän
        jälkeen saat käyttöösi Vilkkeen kaikki ominaisuudet. Nautinnollisia hetkiä 🔥
      </v-alert>

      <v-text-field
        ref="usernameInput"
        v-model="username"
        label="Käyttäjätunnus"
        outlined
      />

      <v-text-field
        v-model="password"
        outlined
        label="Salasana"
        type="password"
      />

      <template
        v-if="isRegistering"
      >
        <v-text-field
          v-model="passwordConfirmation"
          outlined
          label="Salasana uudelleen"
          type="password"
          @blur="showHints = true"
          :hint="showHints && password !== passwordConfirmation ? 'Salasana ei vastaa' : ''"
          persistent-hint
        />

        <v-checkbox
          v-model="isAdult"
          class="mt-2"
          hide-details
        >
          <template v-slot:label>
            <span
              class="caption"
            >
              Olen vähintään 18-vuotias
            </span>
          </template>
        </v-checkbox>

        <v-checkbox
          v-model="gdprConsent"
          hide-details
          class="mt-1 mb-11"
        >
          <template v-slot:label>
            <span
              class="caption"
            >
              Hyväksyn <a
                target="_blank"
                href="/tietosuojaseloste"
                class="ml-1"
                @click.stop
              >
                tietosuojaselosteen
              </a>
            </span>
          </template>
        </v-checkbox>
      </template>

      <v-btn
        :disabled="$wait.is('logging user in') || $wait.is('registering user') || !inputsReady"
        :loading="$wait.is('logging user in') || $wait.is('registering user') "
        color="primary"
        block
        x-large
        type="submit"
      >
        {{ isRegistering ? 'Rekisteröidy' : 'Kirjaudu' }}
      </v-btn>
    </v-card-text>
  </v-form>
</template>

<script>
import { mapWaitingActions } from 'vue-wait';

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    username: '',
    password: '',
    passwordConfirmation: '',
    isAdult: false,
    gdprConsent: false,
    showHints: false,
  }),

  watch: {
    action() {
      this.focusToUsername();
    },
  },

  computed: {
    isLogging() {
      return this.action === 'login';
    },

    isRegistering() {
      return this.action === 'register';
    },

    title() {
      if (this.isRegistering) {
        return 'Rekisteröidy';
      }

      return 'Kirjaudu';
    },

    inputsReady() {
      if (this.isRegistering) {
        return this.username.length > 0
          && this.password.length > 0
          && this.passwordConfirmation.length > 0
          && this.password === this.passwordConfirmation
          && this.isAdult
          && this.gdprConsent;
      }

      return this.username.length > 0
        && this.password.length > 0;
    },
  },

  mounted() {
    this.focusToUsername();
  },

  methods: {
    ...mapWaitingActions('currentUser', {
      login: 'logging user in',
      register: 'registering user',
    }),

    focusToUsername() {
      this.$refs.usernameInput.focus();
    },

    submit() {
      if (this.isRegistering) {
        this.registerUser();
      } else {
        this.loginUser();
      }
    },

    async registerUser() {
      const success = await this.register({
        user: {
          username: this.username,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation,
          isAdult: this.isAdult,
          gdprConsent: this.gdprConsent,
        },
      });

      if (!success) return;

      this.handleRedirect();
    },

    async loginUser() {
      const success = await this.login({
        session: {
          username: this.username,
          password: this.password,
        },
      });

      if (!success) return;

      this.handleRedirect();
    },

    async handleRedirect() {
      const {
        redirect,
      } = this.$route.query;

      let to = '/paakanava/kaikki/uudet';

      if (redirect) {
        to = this.$route.query.redirect;
      }

      await this.$router.push(to);
    },
  },
};
</script>
